import { localStorageUtils } from './localStorage';

// Utility function to reset onboarding for testing
export const resetOnboarding = () => {
  localStorageUtils.clearAll();
  console.log('Onboarding reset - refresh the page to see the onboarding flow again');
};

// Make it available globally for testing in browser console
if (typeof window !== 'undefined') {
  (window as any).resetOnboarding = resetOnboarding;
}
